// biome-ignore lint/correctness/noUnusedImports: Automated migration to Biome
import React from 'react';
import type { Contentful, FrontifyImageContent } from '../../contentful';
import { getFrontifyBackgroundImageUrl } from '../../utils/frontify';
import type { ImageSectionContent } from '../ImageSection/ImageSection';
import useCircleImageStyles from './CircleImage.styles';
import useStyles from './ImageGridFourCirclesText.styles';

interface CircleImageProps {
  title: string;
  image: FrontifyImageContent[];
}

function CircleImage({ title, image }: CircleImageProps) {
  const { classes } = useCircleImageStyles();
  const imagePath = getFrontifyBackgroundImageUrl(image[0].preview_url, 220);
  return (
    <div
      className={classes.container}
      style={{
        background: `linear-gradient(180deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.16) 100%), ${imagePath}`,
      }}
    >
      <p className={classes.text}>{title}</p>
    </div>
  );
}

interface CircleSquareProps {
  imageContent: ImageSectionContent[];
}

function CircleSquare({ imageContent }: CircleSquareProps) {
  const { classes } = useStyles();
  return (
    <div className={classes.circleImageContainer}>
      <div className={classes.circleImageRow}>
        <CircleImage {...imageContent[0].fields} />
        <CircleImage {...imageContent[1].fields} />
      </div>
      <div className={classes.circleImageRow}>
        <CircleImage {...imageContent[2].fields} />
        <CircleImage {...imageContent[3].fields} />
      </div>
    </div>
  );
}

export interface ImageGridFourCirclesTextContent extends Contentful {
  fields: {
    title: string;
    imageContent: ImageSectionContent[];
  };
}

interface Props {
  content: ImageGridFourCirclesTextContent;
}

/**
 * @deprecated V2 component
 */
export default function ImageGridFourCirclesText({ content }: Props) {
  const { title, imageContent } = content.fields;
  const { classes } = useStyles();
  return (
    <div className={classes.container}>
      <div className={classes.textContainer}>
        <h1 className={classes.title}>{title}</h1>
      </div>
      <CircleSquare imageContent={imageContent} />
    </div>
  );
}
